import { useSelector } from 'react-redux';

import { getActiveRegion } from 'reducers';

const useRegion = () => useSelector(getActiveRegion);

export default useRegion;
